export default __webpack_public_path__ + "static/media/rate_eg2.b4b901ed.jpg";